import { applyMiddleware, compose, createStore } from 'redux';
import reducer from './reducer';
import createSagaMiddleware from 'redux-saga';

import saga from './saga';
import sagaSpawn from './sagaSpawn';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(saga);
sagaMiddleware.run(sagaSpawn);
export default store;
